// removed by extract-text-webpack-plugin
module.exports = {"labelTypography":"_2SogU","smallLinkTypography":"_3Q4XU","titleTypography":"_3ifTc","cardTitleTypography":"_29Hzg","nameCell":"_74v4b","truncate":"_36LgG","base":"_1qwgt","emptyresult":"Tgtov","emaildata":"_26UAx","adminSideMenu":"AeD4f"};


//////////////////
// WEBPACK FOOTER
// ./src/views/AdminCentre/components/PersonalInfoList.scss
// module id = 2645
// module chunks = 0